module.exports = __webpack_public_path__ + "img/lambdoge.74fc221b.png";